<template>
  <v-container
    id="usuarioContrasena"
    class="fill-height justify-center"
    tag="section"
  >
    <v-row justify="center">
      <v-slide-y-transition appear> </v-slide-y-transition>

      <v-slide-y-transition appear>
        <base-material-card
          color="secondary"
          light
          max-width="100%"
          width="400"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">
                Olvidé mi contraseña
              </h1>
            </div>
          </template>
          <v-form ref="form" v-model="valid" lazy-validation v-if="mostrar">
          <v-card-text class="text-center">
            <div class="text-center grey--text h-1 font-weight-light">
              Ingresar un correo válido y contraseña
            </div>
            <v-text-field
              color="secondary"
              v-model="email"
              label="Email *"
              prepend-icon="mdi-face"
              class="mt-10"
              required
            />
           
            <div class="body-2 font-weight-light">* Campos Requeridos</div>
            <v-flex class="red--text" v-if="error">{{ error }}</v-flex>
            <pages-btn @click="ingresar" large> Registrar </pages-btn>
          </v-card-text>
</v-form>
            <v-text-field
              class="mb-8"
              v-model="codigo_validacion"
            
              color="secondary"
              label="Ingresar código"
              prepend-icon="mdi-lock-outline"
              required
              :rules="contrasenaConfirmarRules"
              :max="15"
              v-if="!mostrar"
            />
            <pages-btn @click="loader = 'loading', validar()" large v-if="!mostrar" :disabled="!valid"   :loading="loading" >
              Validar
            </pages-btn>
            <v-spacer></v-spacer>
          
         
            <v-spacer></v-spacer>
            <v-chip
              class="ma-2"
              color="success"
              outlined
              :to="{ name: 'Login' }"
            >
              <v-icon left> mdi-arrow-left </v-icon>
              Regresar
            </v-chip>
         
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>
 
 <script>
import axios from "axios";
export default {
  name: "PagesLogin",

  components: {
    PagesBtn: () => import("./components/Btn"),
  },
  data() {
    return {
      mostrar: true,
      email: "",
      password: "",
      error: null,
      loader: null,
      loading: false,
    };
  },
  methods: {
    ingresar() {
      this.error = null;
      axios
        .post("api/Usuarios/Login", {
          email: this.email,
          password: this.password,
        })
        .then((respuesta) => {
          return respuesta.data;
        })
        .then((data) => {
          console.log("login !!");
          console.log(data.token);
          localStorage.setItem("email", this.email);
          this.$store.dispatch("guardarToken", data.token);
          this.$router.push({ name: "Dashboard" });
        })
        .catch((err) => {
          //console.log(err.response);
          if (err.response.status == 400) {
            this.error = "Invalid email or password";
          } else if (err.response.status == 404) {
            this.error = "Invalid email or password";
          } else {
            this.error = "Ocurrió un error";
          }
          //console.log(err)
        });
    },
  },
};
</script>
 
 